<template>
  <span
    v-if="use"
    class="jade-brand"
    :class="computedClassList"
    v-bind="$attrs"
  >
    <component :is="computedDynamicIcon" />
  </span>
</template>

<script>
import SIZE_ENUM from '../enums/sizes.enum'

export default {
  name: 'jade-brand',

  props: {
    use: {
      type: String,
      required: true
    },
    size: {
      type: String,
      validation: size => Object.values(SIZE_ENUM).includes(size),
      default: SIZE_ENUM.LARGE
    }
  },

  computed: {
    computedClassList () {
      return {
        [`is-${this.size}`]: this.size
      }
    },
    computedDynamicIcon () {
      return this.use
        ? () =>
            import(
              /* webpackChunkName: "jade-design-tokens/icons/[request]" */ '@stone-payments/jade-design-tokens/brands/' +
                this.use +
                '.svg?inline'
            )
        : ''
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/brand.css';
</style>
